import { render, staticRenderFns } from "./customer-features-modal.vue?vue&type=template&id=0db37d9a&scoped=true&"
import script from "./customer-features-modal.vue?vue&type=script&lang=js&"
export * from "./customer-features-modal.vue?vue&type=script&lang=js&"
import style0 from "./customer-features-modal.vue?vue&type=style&index=0&id=0db37d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db37d9a",
  null
  
)

export default component.exports